import React, { useState } from 'react';
import ProviderList from '../components/ProviderList';
import ProviderForm from '../components/ProviderForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';
import '../components/QuickCreateModal.css';

function ProvidersPage() {
  const [editingProvider, setEditingProvider] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const width = useWindowWidth();
  const isDesktop = width >= 768;

  const handleEdit = (provider) => {
    setEditingProvider(provider);
    setShowForm(true);
  };

  const handleNewProvider = () => {
    setEditingProvider(null);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingProvider(null);
  };

  const handleSuccess = () => {
    handleClose();
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Fornecedores</h1>
            <p>Gerencie seus fornecedores</p>
          </div>
          <button className="rv-btn rv-btn-primary" onClick={handleNewProvider}>
            + Novo Fornecedor
          </button>
        </div>
      )}

      {/* ── Mobile header ── */}
      {!isDesktop && <h1>Gerenciamento de Fornecedores</h1>}

      {/* Lista sempre visível */}
      <ProviderList
        onEdit={handleEdit}
        refreshTrigger={refreshTrigger}
        onNewProvider={handleNewProvider}
      />

      {/* Modal com o formulário */}
      {showForm && (
        <div
          className="qc-overlay"
          onClick={e => { if (e.target === e.currentTarget) handleClose(); }}
        >
          <div className="qc-box qc-box--wide">
            <div className="qc-header">
              <span className="qc-title">
                {editingProvider ? 'Editar Fornecedor' : 'Novo Fornecedor'}
              </span>
              <button type="button" className="qc-close" onClick={handleClose} aria-label="Fechar">✕</button>
            </div>
            <div className="qc-body">
              <ProviderForm provider={editingProvider} onSuccess={handleSuccess} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProvidersPage;
